import React from "react";
import { LANGS } from "../lib/i18n.jsx";
import { Input } from "./ui/input";

export default function TransInput({ value, onChange, placeholder }) {
  const v = value || {};
  return (
    <div className="grid grid-cols-2 gap-2">
      {LANGS.map((l) => (
        <div key={l.code} className="relative">
          <span className="absolute left-2 top-1/2 -translate-y-1/2 text-xs">{l.flag}</span>
          <Input data-testid={`trans-${l.code}`} className="pl-8 h-9 text-sm" placeholder={placeholder}
            value={v[l.code] || ""} onChange={(e) => onChange({ ...v, [l.code]: e.target.value })} />
        </div>
      ))}
    </div>
  );
}
